var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"value":_vm.randomize,"color":"green"},on:{"change":function($event){return _vm.$emit('update:randomize', $event)}}},[_c('v-btn',{attrs:{"value":true,"small":""}},[_c('svg-icon',{attrs:{"icon":"random"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }